
import { defineComponent, ref, computed, onMounted, onUnmounted } from 'vue'

export default defineComponent({
  name: 'VideoModal',
  props: {
    videoId: {
      type: String,
      required: true
    },
    autoplay: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close'],
  setup(props, { emit }) {
    const isLoading = ref(true)
    const videoIframe = ref<HTMLIFrameElement | null>(null)

    // Вычисляем URL видео с учётом настроек
    const videoSrc = computed(() => {
      const params = new URLSearchParams({
        rel: '0',
        origin: window.location.origin,
        enablejsapi: '1',
        modestbranding: '1',
        "iv_load_policy": '3'
      })

      if (props.autoplay) {
        params.append('autoplay', '1')
      }

      return `https://www.youtube.com/embed/${props.videoId}?${params.toString()}`
    })

    // Обработчик загрузки iframe
    const onIframeLoad = () => {
      isLoading.value = false
    }

    // Закрытие модального окна
    const closeModal = (event?: Event) => {
      // Предотвращаем всплытие события
      if (event) {
        event.stopPropagation()
      }
      emit('close')
    }

    // Обработчик клавиши Escape
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeModal()
      }
    }

    // Фиксируем body при открытии модального окна
    const lockBodyScroll = () => {
      document.body.style.overflow = 'hidden'
    }

    // Возвращаем прокрутку после закрытия
    const unlockBodyScroll = () => {
      document.body.style.overflow = ''
    }

    onMounted(() => {
      // Добавляем обработчик клавиши Escape
      window.addEventListener('keydown', handleEscKey)
      // Блокируем прокрутку страницы
      lockBodyScroll()
    })

    onUnmounted(() => {
      // Удаляем обработчик клавиши Escape
      window.removeEventListener('keydown', handleEscKey)
      // Разблокируем прокрутку страницы
      unlockBodyScroll()
    })

    return {
      isLoading,
      videoIframe,
      videoSrc,
      onIframeLoad,
      closeModal
    }
  }
})
